import React, { useEffect, useState } from "react";
import { slimImage } from "@/service/utils";
import { useStores } from "@/store";
import "./index.less";
import { Link } from "react-router-dom";

/**
 * 餐厅信息
 *
 * @returns
 */
const Restaurant = ({ deal, odd }) => {
  const { memberStore } = useStores();
  const [distance, setDistance] = useState("");
  useEffect(() => {
      if (undefined != deal.restaurant) {
          const {lat, lng} = deal.restaurant;
          setDistance(memberStore.getDistance(lat, lng));
      }
  }, []);
  return (
    <Link
      to={`/deals/${deal.id}`}
      target="_blank"
      className="deal-item"
      data-odd={odd}
    >
      <article>
        <div className="deal-item--image">
          <img src={slimImage(deal.picture_url, "/w/148/h/100")} alt="" />
        </div>
        <div className="deal-item--content">
          <div className="deal-title">{deal.name}</div>
          <div className="deal-description ellipsis">
            {deal.restaurant_name}
          </div>
          <div className="deal-tags">{deal.category_name}</div>
          <div className="deal-footer">
            <span className="deal-location small">
              <i className="icon icon-location" data-size="mini"></i>
              {deal.locations[0].name}
              <span style={{ marginLeft: 10 }}>{distance}</span>
            </span>
            <span className="deal-price-desc">
              {deal.price_desc[0]}
              {deal.category_keyword === "discount" ? (
                <i>￥{deal.original_price}</i>
              ) : null}
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default Restaurant;
